import React from "react";
import { NavBtn, Splitter, Switcher } from "./navBtnStyles";
import { useTranslation } from "react-i18next";
import { convertToUpperCase } from "../../utils/helpers/convertToUpperCase";

const LanguageSwitch = (props) => {
  const { t } = useTranslation();

  const handleChangeLang = ({ lang }) => {
    if (lang === props.currentLanguageCode) {
      return;
    }
    props.changeLanguage(lang);
  };

  return (
    <Switcher>
      <NavBtn
        onClick={() => handleChangeLang({ lang: "ka" })}
        className={props.currentLanguageCode === "ka" && "active"}
      >
        {convertToUpperCase(t("languageGe"))}
      </NavBtn>
      <Splitter>|</Splitter>
      <NavBtn
        onClick={() => handleChangeLang({ lang: "en" })}
        className={props.currentLanguageCode === "en" && "active"}
      >
        {convertToUpperCase(t("languageEn"))}
      </NavBtn>
    </Switcher>
  );
};

export default LanguageSwitch;
